import { HttpInterceptorFn } from '@angular/common/http';

export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
  const tenantSlug = 'mentebonita';
  const cloned = req.clone({
    setHeaders: {
      'X-Tenant-ID': tenantSlug,
    },
  });

  return next(cloned);
};
